import React, { useRef, useEffect, useState } from "react";
import _ from "lodash";
import ReportsTable from "./ReportsTable";

const ReportsIndex = (props) => {
  return <ReportsTable />;
};

export default ReportsIndex;
